import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';
export default class OwnerBusiness implements IOwner {
    constructor(owner: OwnerBusiness) {
        Object.assign(this, owner);
    }

    id: number;
    ownerType: string;
    name: string;
    address: Address;
    phoneNumberChanges?: PhoneNumberChanges;
    contactPersonDetailsId: number;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    contactPersonTitle: string;
    email: string;
    addressInformationDate?: Date;
    containerOwnerId?: number;
    ownerLookUpId?: number;
    note?: string;
    isPrimaryDeviation?: boolean;
    addressId: number;
    isClientAcreage: boolean;
    ssnTaxId: string;

    ownerName() {
        return this.name;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerBusiness.ts